import React, {Component} from 'react'
import {Badge, Modal, Icon, Button} from "antd"
import PropTypes from 'prop-types'

class ModalReGenerate extends Component {
    componentDidMount() {
        const {onRefresh} = this.props

        this.interval = setInterval(() => {
            !this._isFinish() && onRefresh()
        }, 5000)
    }

    _handleCloseModal = () => {
        const {closeModal, reloadListSessions} = this.props

        closeModal()
        reloadListSessions()
    }

    _isFinish = () => {
        const {data} = this.props
        return !data.find(item => item.status !== 'done' && item.status !== 'error')
    }

    _stopInterval() {
        clearInterval(this.interval)
    }

    componentWillUnmount() {
        this._stopInterval()
    }

    _genStatus = (status) => {
        let iconStatus = ''
        switch (status) {
            case 'pending':
                iconStatus = <Badge
                    count={status}
                    style={{backgroundColor: '#03a9f4', color: '#fff'}}
                />
                break
            case 'processing':
                iconStatus = <Badge
                    count={status}
                    style={{backgroundColor: '#00acc1', color: '#fff'}}
                />
                break
            case 'done':
                iconStatus = <Badge
                    count={status}
                    style={{backgroundColor: '#00c853', color: '#fff'}}
                />
                break
            case 'error':
                iconStatus = <Badge
                    count={status}
                    style={{backgroundColor: '#dc3545', color: '#fff'}}
                />
                break
            default:
        }
        return iconStatus
    }

    render() {
        const {showModal, data, error} = this.props

        return (
            <Modal
                title="Generate lại file in"
                visible={showModal}
                onCancel={this._handleCloseModal}
                footer={[
                    <div key="footer" className="Footer d-flex justify-content-between align-items-center">
                        <div>
                            {
                                (!this._isFinish()) && (
                                    <div className="mr-3"><Icon type="sync" spin className='text-success'/> Đang generate lại file in...</div>
                                )
                            }
                        </div>
                        <Button type="primary" onClick={this._handleCloseModal}>
                            Đóng
                        </Button>
                    </div>,
                ]}
            >
                {
                    data.length > 0 && (
                        <div>
                            <div className="mb-3">
                                <div className="mb-3">Các items đang generate lại file in:</div>
                                {
                                    data.map((item, index) => {
                                        return (
                                            <div className="mb-1" key={index}>
                                                {this._genStatus(item.status)}
                                                <strong className='ml-2'>#{item.barcode_number}</strong>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            {
                                (error) && <div className="text-danger mb-3">{error}</div>

                            }
                        </div>
                    )
                }
            </Modal>
        )
    }

}

ModalReGenerate.propTypes = {
    showModal: PropTypes.bool.isRequired,
    data: PropTypes.array,
    closeModal: PropTypes.func.isRequired,
    error: PropTypes.string,
    reloadListSessions: PropTypes.func.isRequired
}

export default ModalReGenerate